import script from "./SideBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./SideBar.vue?vue&type=script&setup=true&lang=ts"

import "./SideBar.vue?vue&type=style&index=0&id=6baccdca&lang=scss"

const __exports__ = script;

export default __exports__